module.exports = __webpack_public_path__ + "img/Logotype.3f450fca.svg";